// lib/config.js

export const SITE_URL = import.meta.env.DEV
  ? "http://localhost:5173" // or 3000 if you've changed it
  : import.meta.env.VITE_SITE_URL || "https://footy-coach.vercel.app";

export const GA4_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID;

// Feature flags
export const PAYMENTS_ENABLED = import.meta.env.VITE_PAYMENTS_ENABLED === 'true';

// Maximum friends per user. Must match the DB enforcement in the
// check_friend_limit() trigger (see .database_migrations). Keep the two in sync.
export const MAX_FRIENDS = 5000;

// Page size for paginated friend lists (get_friends_page RPC).
export const FRIENDS_PAGE_SIZE = 50;